/**
 * Sanitizes a formik field name.  Removes periods that cause problems.
 * @param name filed name
 * @return formik safe name
 */
export function sanitizeFieldName(name: string): string {
  return name.replaceAll(".", "");
}
